// Serialize an SVG element and rasterize it into a PNG blob.
// The blob is downloaded via a temporary <a> tag with the given filename.
export const exportSvgAsPng = async (svgEl, filename = "training-ground.png", scale = 2) => {
  if (!svgEl) throw new Error("No SVG element provided");

  const vb = svgEl.viewBox && svgEl.viewBox.baseVal;
  const w = (vb && vb.width) || svgEl.clientWidth || 800;
  const h = (vb && vb.height) || svgEl.clientHeight || 600;

  const clone = svgEl.cloneNode(true);
  clone.setAttribute("xmlns", "http://www.w3.org/2000/svg");
  clone.setAttribute("width", String(w));
  clone.setAttribute("height", String(h));

  // Inline a fallback font-family so text renders even if webfonts aren't
  // available inside the rasterization context.
  clone.querySelectorAll("text").forEach((t) => {
    const ff = t.getAttribute("font-family") || "";
    if (!ff.includes("sans-serif")) {
      t.setAttribute(
        "font-family",
        "Manrope, IBM Plex Sans, Helvetica, Arial, sans-serif"
      );
    }
  });

  const source = new XMLSerializer().serializeToString(clone);
  const svgBlob = new Blob([source], { type: "image/svg+xml;charset=utf-8" });
  const svgUrl = URL.createObjectURL(svgBlob);

  await new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      try {
        const canvas = document.createElement("canvas");
        canvas.width = Math.round(w * scale);
        canvas.height = Math.round(h * scale);
        const ctx = canvas.getContext("2d");
        ctx.fillStyle = "#FFFFFF";
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        URL.revokeObjectURL(svgUrl);
        canvas.toBlob((blob) => {
          if (!blob) return reject(new Error("PNG encoding failed"));
          const a = document.createElement("a");
          a.href = URL.createObjectURL(blob);
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          setTimeout(() => URL.revokeObjectURL(a.href), 1000);
          resolve();
        }, "image/png");
      } catch (e) {
        URL.revokeObjectURL(svgUrl);
        reject(e);
      }
    };
    img.onerror = (e) => {
      URL.revokeObjectURL(svgUrl);
      reject(e);
    };
    img.src = svgUrl;
  });
};
